import { StorageKey, FetchResponse } from 'models';
import Mapper from 'data/Mapper';
import Storage from './Storage';

class LocalStorage {
  get = async <T>(key: StorageKey): Promise<FetchResponse<T | null>> => {
    try {
      let result = null;
      const data = await Storage.get(key.toString());
      if (data) {
        result = JSON.parse(data);
      }
      return Mapper.mapSuccesResponse(result);
    } catch (error) {
      return Mapper.mapError(error);
    }
  };

  set = async <T>(key: StorageKey, data: T): Promise<FetchResponse<{}>> => {
    try {
      await Storage.set(key.toString(), JSON.stringify(data));
      return Mapper.mapSuccesResponse({});
    } catch (error) {
      return Mapper.mapError(error);
    }
  };

  remove = async (key: StorageKey): Promise<FetchResponse<{}>> => {
    try {
      await Storage.remove(key.toString());
      return Mapper.mapSuccesResponse({});
    } catch (error) {
      return Mapper.mapError(error);
    }
  };
}

export default new LocalStorage();
